import React from 'react';

import { BettingWidgets, DEBUG_INFO_LOCALSTORAGE_KEY } from 'app-constants';
import { useWidgetSettings } from 'hooks';
import { checkWidgetContainerProvided } from 'utils';
import Portal from '../Portal';

interface Props {
    widget: BettingWidgets;
    children: React.ReactElement;
    isPageDisabled?: boolean;
    replacePortalContent?: boolean;
    isFilled?: boolean;
}

const Widget: React.FC<Props> = ({
    widget,
    children,
    isPageDisabled = false,
    replacePortalContent = false,
    isFilled,
}) => {
    const widgetSettings = useWidgetSettings({ widget });

    if (!checkWidgetContainerProvided(widgetSettings)) {
        return children;
    }

    const { containerElementId } = widgetSettings;

    if (containerElementId === null) return null;

    const node = document.getElementById(containerElementId);

    if (!node) {
        if (localStorage.getItem(DEBUG_INFO_LOCALSTORAGE_KEY)) {
            console.warn(
                `Container element for widget "${widget}" with id "${containerElementId}" is missing`
            );
        }

        return null;
    }

    // TODO: remove hardcode
    if (widget === BettingWidgets.SETTINGS) {
        node.style.display = 'flex';
    }

    return (
        <Portal
            isPageDisabled={isPageDisabled}
            parentNode={node}
            replaceContent={replacePortalContent}
            isFilled={isFilled}
        >
            {children}
        </Portal>
    );
};

export default React.memo(Widget);
